<template>
  <!--
    Full-screen flex column glued to the visual viewport (see useVisualViewport).
    The whole page does not scroll; only the inner <main> of the chat core does.
    This replaces a `position: fixed` input bar, which iOS WKWebView mispositions
    once the keyboard opens.
  -->
  <div
    class="bg-surface-default-low mood-warm fixed inset-x-0 top-0 flex flex-col overflow-hidden"
    :style="viewportStyle"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue'

import { useVisualViewport } from '~/scopes/webviews/useVisualViewport'

// Keeps the chat root sized to the area above the on-screen keyboard.
const { style: viewportStyle } = useVisualViewport()

// These pages are full-screen position:fixed layouts, so their document
// never scrolls. Lock document-level overscroll while mounted so a swipe that
// starts outside the inner scroller (e.g. on the header or input bar) can't
// rubber-band the WKWebView root scroll view and drag the native modal down on
// iOS. The scope is the page lifecycle only — webview-default is shared with
// pages (help-center, generic webviews) that do rely on document scrolling, so
// we restore the previous value on unmount.
let previousOverscrollBehavior = ''
onMounted(() => {
  previousOverscrollBehavior = document.documentElement.style.overscrollBehavior
  document.documentElement.style.overscrollBehavior = 'none'
})
onUnmounted(() => {
  document.documentElement.style.overscrollBehavior = previousOverscrollBehavior
})
</script>
